import { render, staticRenderFns } from "./Resultado.vue?vue&type=template&id=9f108668"
import script from "./Resultado.vue?vue&type=script&lang=js"
export * from "./Resultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports